import { render, staticRenderFns } from "./photo-company.vue?vue&type=template&id=9b70779a&scoped=true&"
import script from "./photo-company.vue?vue&type=script&lang=js&"
export * from "./photo-company.vue?vue&type=script&lang=js&"
import style0 from "./photo-company.vue?vue&type=style&index=0&id=9b70779a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b70779a",
  null
  
)

export default component.exports